import { fetchAllSwellEvents } from '../common/api/feed';

export const FETCH_SWELL_EVENTS = 'FETCH_SWELL_EVENTS';
export const FETCH_SWELL_EVENTS_SUCCESS = 'FETCH_SWELL_EVENTS_SUCCESS';
export const FETCH_SWELL_EVENTS_FAILURE = 'FETCH_SWELL_EVENTS_FAILURE';

export const fetchSwellEvents = () => async dispatch => {
  dispatch({
    type: FETCH_SWELL_EVENTS,
  });

  try {
    const { events } = await fetchAllSwellEvents();
    dispatch({
      type: FETCH_SWELL_EVENTS_SUCCESS,
      events,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SWELL_EVENTS_FAILURE,
      error,
    });
  }
};
